import { defineComponent as _defineComponent } from 'vue'
import { useRirekishoPreview } from '@/composables/format-edit/useRirekishoPreview'

type FormatPreviewSfcProps = {
  formatData: Record<string, any>
  basicData: Record<string, any>
  previewScale?: number
  currentCardId?: string | string[]
  idPrefix?: string
  isSample?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NewRirekishoSinglePreview',
  props: {
    formatData: null,
    basicData: null,
    previewScale: { default: 1 },
    currentCardId: { default: '' },
    idPrefix: { default: '' },
    isSample: { type: Boolean, default: false }
  },
  setup(__props: any, { expose }) {

const props = __props as { formatData: Record<string, any>, basicData: Record<string, any>, previewScale: number, currentCardId: string | string[], idPrefix: string, isSample: boolean };



const {
  checkValid,
  formLib,
  scaleStyle,
  goCardTo,
  highLightClass,
  classObject,
  errorMessages,
  tel,
  age,
  formatedCreateDate,
  isMale,
  isFemale,
  isGenderDisplay,
  eduJobHistoryTable4New,
  licenseHistoryTable
} = useRirekishoPreview(props, {
  maxEduJobRows: 8,
  maxLicenseRows: 4,
  textareaMaxHeights: { reason: 180, reasonNew: 160, request: 70 },
  useEduJobTable4New: true,
  optionItems: { commuteDescription: false }
})

expose({ checkValid })

return { __sfc: true,props, checkValid, formLib, scaleStyle, goCardTo, highLightClass, classObject, errorMessages, tel, age, formatedCreateDate, isMale, isFemale, isGenderDisplay, eduJobHistoryTable4New, licenseHistoryTable }
}

})